import NumberOnly from './number-only';

const install = function(Vue) {
  Vue.directive('NumberOnly', NumberOnly);
};

if (window.Vue) {
  Vue.use(install); // eslint-disable-line
}

NumberOnly.install = install;
export default NumberOnly;